import {useState} from "react";
import Turnstile from "./Turnstile";
import {properties} from "../properties";

// Renders the Turnstile widget when a site key is configured (nothing otherwise), with a
// visible message and retry link if the Cloudflare script cannot load, so users are never
// stuck staring at a disabled button with no explanation.
function CaptchaField({onToken}) {

    const [loadFailed, setLoadFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);

    if (!properties.turnstileSiteKey) {
        return null;
    }
    if (loadFailed) {
        return (
            <div className={"no-account"}>
                <span>Human verification could not load (an ad blocker may be interfering). </span>
                <span className={"click-here"}
                      onClick={() => {
                          setLoadFailed(false);
                          setAttempt(attempt + 1);
                      }}>
                    Try again
                </span>
            </div>
        );
    }
    return <Turnstile key={attempt}
                      siteKey={properties.turnstileSiteKey}
                      onToken={onToken}
                      onError={() => setLoadFailed(true)}/>;
}

export default CaptchaField;
